module.exports = __webpack_public_path__ + "static/media/user-name.cd977051.svg";